/* import __COLOCATED_TEMPLATE__ from './file-input-button.hbs'; */
import { computed } from '@ember/object';
import Component from '@ember/component';

/**
 * A component which renders a file input button.
 */
export default Component.extend({
  /**
   * @inheritDoc
   */
  classNames: ['SH-c-file-input-button'],

  /*********************************
   * REQUIRED PARAMS
   *********************************/

  handleChange: () => (function() {}),

  /*********************************
   * OPTIONAL PARAMS
   *********************************/

  /**
   * @param {Boolean} isDisabled Whether the button is disabled.
   */
  isDisabled: false,

  /**
   * @param {String} buttonType The type of button to render ('icon'|'text').
   */
  buttonType: 'icon',

  /**
   * @param {String} buttonText The text inside the button (only matters if button type is 'text').
   */
  buttonText: 'Add file(s)',

  /*********************************
   * PRIVATE
   *********************************/

  /**
   * @type {String} A sufficiently unique ID for the <input> element.
   */
  _inputID: computed('elementId', function() {
    return `file-input-${this.get('elementId').replace('ember', '')}`;
  }),

  actions: {
    onChange(event) {
      const input = event.target;
      this.get('handleChange')(input.files);
      input.value = '';
    },
  },
});
